<template>
    <div class="cursor-pointer" @click="$route.query.back ? $router.push($route.query.back) : $router.go(-1)">
        <b-icon-x scale="3" class="text-white"></b-icon-x>
    </div>
</template>

<script>
    export default {
        name: "Close"
    }
</script>

<style scoped>

</style>
